import { render, staticRenderFns } from "./Sidebar.html?vue&type=template&id=b0ce2c82&external"
import script from "./Sidebar.ts?vue&type=script&lang=ts&external"
export * from "./Sidebar.ts?vue&type=script&lang=ts&external"
import style0 from "./Sidebar.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports